import { Scroll } from '../../utilities/scroll/index';
export default ($container) => {

    const screen = $('html,body');
    const details = $('.product-details');
    const detailsContainer = '.js-toggle-product-details';
    const detailsHeadline = $container.find(detailsContainer);
    let timeout = null;
    let scrollTo;

    $container.find('.js-show-product-details').on('click', function (e) {
        e.preventDefault();
        const scrollTo = details.offset().top + 1;

        if (timeout) {
            clearTimeout(timeout);
        }

        if (!details.hasClass('product-toggle--opened')) {
            detailsHeadline.trigger('click');
            timeout = setTimeout(function () {
                // screen.animate({ scrollTop: scrollTo }, 350);
                Scroll(document.querySelector('.product-toggle--opened'));
            }, 800);
        } else {
            Scroll(document.querySelector('.product-toggle--opened'));
            // screen.animate({ scrollTop: scrollTo }, 350);
        }
    });
};
